import React from 'react';

const Menu = () => {
  return (
    <div className="min-h-screen pt-20 bg-gray-300 relative" style={{
      backgroundImage: `
        linear-gradient(rgba(128, 128, 128, 0.7), rgba(128, 128, 128, 0.7)),
        url("/images/backgrounds/dining-bg.webp"),
        url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='m36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")
      `,
      backgroundSize: 'cover, cover, 60px 60px',
      backgroundPosition: 'center, center, 0 0',
      backgroundRepeat: 'no-repeat, no-repeat, repeat',
      filter: 'grayscale(0.3)'
    }}>
      {/* Header Section */}
      <div className="pt-20 relative" id="div-3">
        <h1 className="text-[3.25rem] leading-none font-medium pt-24 text-center uppercase my-3 mx-0 mb-3 text-black" id="h1-1">
          Our Menu
        </h1>

        {/* Customer Advisory */}
        <div className="pb-8 text-center w-4/5 m-auto">
          <p className="m-[initial] text-sm text-black">
            *Items cooked to order. Consuming raw or undercooked meats, poultry, seafood, shellfish, or eggs may increase your risk of foodborne illness, especially if you have certain medical conditions.
          </p>
        </div>
      </div>

      {/* Menu Content */}
      <div className="pb-10 px-4 pt-3 m-auto max-w-7xl">
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">

          {/* Starters Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Starters</h2>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Hand Breaded Apps</h3>
                </div>
                <p className="text-sm text-gray-700">Choice of 1: Mushrooms, Banana Peppers, Pickles, Cheese Curds | Hand breaded, fried crisp, and served with ranch</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Cheese Fries</h3>
                </div>
                <p className="text-sm text-gray-700">A pile of fries, topped with melted cheddar & jack cheese, nacho cheese or queso | Add bacon or homemade chili</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Quesadillas</h3>
                </div>
                <p className="text-sm text-gray-700">Flour tortilla with cheddar & jack cheese and your choice of:</p>
                <ul className="text-sm text-gray-700 list-disc pl-5 mt-1">
                  <li>Cheese or Veggie</li>
                  <li>Grilled Chicken</li>
                  <li>Steak, Brisket, or Cheeseburger</li>
                </ul>
                <p className="text-sm text-gray-700 mt-1 italic">Served with lettuce, tomatoes, jalapeños, sour cream, and salsa</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Buffalo Style Shrimp</h3>
                </div>
                <p className="text-sm text-gray-700">Fried shrimp, tossed in your choice of sauce, served with ranch or bleu cheese & a bed of lettuce</p>
                <p className="text-sm text-gray-700 mt-1">5 Piece | 10 Piece</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Funnel Cake Fries</h3>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Buffalo Chicken Dip</h3>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Jalapeño Poppers (6)</h3>
                </div>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Skins</h3>
                </div>
                <p className="text-sm text-gray-700">Huge, scooped and stuffed potatoes with melted cheddar & jack cheese, served with sour cream and your choice of:</p>
                <p className="text-sm text-gray-700 mt-1">Bacon | Chicken | Brisket</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Mozzarella Sticks</h3>
                </div>
                <p className="text-sm text-gray-700">Breaded and fried mozzarella, served with marinara (6 sticks)</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Soft Pretzels</h3>
                </div>
                <p className="text-sm text-gray-700">Soft pretzel sticks, served with beer cheese</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Poutine</h3>
                </div>
                <p className="text-sm text-gray-700">A pile of fries, baked with cheese curds, topped with gravy</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Boneless Wings</h3>
                </div>
                <p className="text-sm text-gray-700">6 | 12</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Wings</h3>
                </div>
                <p className="text-sm text-gray-700">6 or 12 Traditional wings, fried crisp | Tossed in your choice of sauce and served with ranch or bleu cheese</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Nachos</h3>
                </div>
                <p className="text-sm text-gray-700">Chicken | Chili | Cheese</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken Tenders</h3>
                </div>
                <p className="text-sm text-gray-700">3 Fried Tenders OR 3 Grilled Tenders</p>
              </div>
            </div>
          </div>

          {/* Wraps Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Wraps</h2>
            <p className="text-center text-sm text-gray-500 mb-4 italic">(Served with side)</p>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Fajita</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled peppers & onions, cheddar and spicy ranch</p>
                <p className="text-sm text-gray-700 mt-1">Chicken | Steak</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Caesar</h3>
                </div>
                <p className="text-sm text-gray-700">Romaine with Caesar dressing and parmesan</p>
                <p className="text-sm text-gray-700 mt-1">Chicken | Steak</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Turkey or Chicken</h3>
                </div>
                <p className="text-sm text-gray-700">Lettuce, tomato, onions, cheddar, and mayo</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken Bacon Ranch</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled or fried, lettuce, tomato, cheddar and ranch</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Buffalo Chicken</h3>
                </div>
                <p className="text-sm text-gray-700">Fried or grilled, lettuce, tomato, cheddar, mild sauce & choice of bleu cheese or ranch</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Veggie</h3>
                </div>
                <p className="text-sm text-gray-700">Lettuce, tomato, cucumber, onion, green pepper, cheddar, and Italian dressing</p>
              </div>
            </div>
          </div>

          {/* Build a Burger & Hot Dog Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Build a Burger & Hot Dog</h2>
            <p className="text-center text-sm text-gray-500 mb-4 italic">(Served with side)</p>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Burger</h3>
                </div>
                <p className="text-sm text-gray-700">Lettuce, tomato & onions</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">2 Angus Beef Hot Dogs</h3>
                </div>
                <p className="text-sm text-gray-700">With two toppings</p>
              </div>

              <div className="pb-3">
                <h3 className="font-bold text-yellow-800 mb-2">Toppings</h3>
                <p className="text-sm text-gray-700">
                  American cheese, Bleu cheese crumbles, Cheddar, Monterey Jack, Swiss, Provolone,
                  Bacon, Chili, Sauerkraut,
                  Onions, Peppers, Mushrooms, Jalapeños, Banana Peppers, Cole slaw,
                  Fried Egg
                </p>
                <h3 className="font-bold text-yellow-800 mt-3 mb-1">Sauces & Dressings</h3>
              </div>
            </div>
          </div>

          {/* Specialty Burgers Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Specialty Burgers</h2>
            <p className="text-center text-sm text-gray-500 mb-4 italic">(Served with side)</p>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <h3 className="font-bold text-yellow-800">Black & Bleu Burger</h3>
                <p className="text-sm text-gray-700">Lettuce, tomato, onions, Cajun seasoning & bleu cheese</p>
              </div>
              <div className="border-b border-gray-200 pb-3">
                <h3 className="font-bold text-yellow-800">Breakfast</h3>
                <p className="text-sm text-gray-700">Lettuce, tomato, onions, bacon, American cheese & fried egg</p>
              </div>
              <div className="border-b border-gray-200 pb-3">
                <h3 className="font-bold text-yellow-800">Carolina Burger</h3>
                <p className="text-sm text-gray-700">Onions, chili, coleslaw & cheddar cheese</p>
              </div>
              <div className="border-b border-gray-200 pb-3">
                <h3 className="font-bold text-yellow-800">Ultimate Burger</h3>
                <p className="text-sm text-gray-700">Lettuce, onions, pickles, American cheese & 1000 Island dressing</p>
              </div>
              <div className="border-b border-gray-200 pb-3">
                <h3 className="font-bold text-yellow-800">The Philly Burger</h3>
                <p className="text-sm text-gray-700">Topped with grilled peppers, onion, and provolone</p>
              </div>
              <div className="pb-3">
                <h3 className="font-bold text-yellow-800">Mushroom & Swiss Burger</h3>
                <p className="text-sm text-gray-700">Grilled mushrooms, Swiss cheese, lettuce, tomato & onions</p>
              </div>
            </div>
          </div>

          {/* Sandwiches Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Sandwiches</h2>
            <p className="text-center text-sm text-gray-500 mb-4 italic">(Served with side)</p>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Grinder</h3>
                </div>
                <p className="text-sm text-gray-700">Tips, with grilled onions, peppers, mushrooms, topped with cheddar</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Philly</h3>
                </div>
                <p className="text-sm text-gray-700">Shaved sirloin or chicken, grilled peppers, onions, cheddar</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Brisket</h3>
                </div>
                <p className="text-sm text-gray-700">Smoked brisket, topped with cheddar and BBQ on grilled brioche</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Hot Ham and Cheese</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled ham, topped with American on a grilled brioche</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">BLT</h3>
                </div>
                <p className="text-sm text-gray-700">Bacon, lettuce, tomato and mayo on toast</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Turkey Melt</h3>
                </div>
                <p className="text-sm text-gray-700">Turkey, Swiss, cheddar, bacon and tomato on Texas Toast</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Fried Cod</h3>
                </div>
                <p className="text-sm text-gray-700">Lettuce, tomato & side of tartar sauce</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Italian Sub</h3>
                </div>
                <p className="text-sm text-gray-700">Hot or cold, with ham, pepperoni, bacon, lettuce, tomato, onions, provolone & Italian dressing</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Roadrunner</h3>
                </div>
                <p className="text-sm text-gray-700">Turkey with grilled onions, mushrooms and peppers topped with Monterey Jack cheese</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">French Dip</h3>
                </div>
                <p className="text-sm text-gray-700">Shaved sirloin topped with provolone cheese, served with Au Jus</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Steak Sandwich</h3>
                </div>
                <p className="text-sm text-gray-700">Lettuce, tomato, and mayo on grilled Brioche</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Patty Melt</h3>
                </div>
                <p className="text-sm text-gray-700">On rye with grilled onions and Swiss cheese</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken (Grilled or Fried)</h3>
                </div>
                <p className="text-sm text-gray-700">Lettuce, tomato, and mayo</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken Club</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled or fried, American cheese, bacon, lettuce & tomato on a brioche bun</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Reuben</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled rye, corned beef, Swiss cheese, sauerkraut, and 1000 Island dressing</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Meatball Parm Sub</h3>
                </div>
                <p className="text-sm text-gray-700">Baked homemade meatballs with marinara and provolone</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken Parm Sub</h3>
                </div>
                <p className="text-sm text-gray-700">Fried chicken with marinara and provolone</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Classic Club</h3>
                </div>
                <p className="text-sm text-gray-700">Ham, turkey, bacon, American cheese, lettuce, tomato, and mayo on Texas toast</p>
              </div>
            </div>
          </div>

          {/* Dinners Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Dinners</h2>
            <p className="text-center text-sm text-gray-500 mb-4 italic">(Served with salad)</p>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chopped Steak</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled mushrooms and gravy</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Brown Sugar Bourbon BBQ Meatloaf</h3>
                </div>
                <p className="text-sm text-gray-700">Homemade meatloaf topped with bourbon BBQ sauce, served with green beans & one choice of side (10 pieces)</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Fried Shrimp Dinner</h3>
                </div>
                <p className="text-sm text-gray-700">Golden fried shrimp, served with slaw & your choice of cocktail or tartar with side | Tossed in Buffalo</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Spaghetti</h3>
                </div>
                <p className="text-sm text-gray-700">Topped with homemade marinara & side of garlic bread | Add two meatballs</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Fettuccine Alfredo</h3>
                </div>
                <p className="text-sm text-gray-700">With a side of garlic bread | Add chicken and broccoli</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Ragin' Cajun Pasta</h3>
                </div>
                <p className="text-sm text-gray-700">Cajun grilled chicken with sautéed garlic & tomatoes, bowtie pasta and garlic bread</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken Tenders</h3>
                </div>
                <p className="text-sm text-gray-700">Tossed in your choice of wing sauce, ranch or bleu cheese and choice of side</p>
                <p className="text-sm text-gray-700 mt-1">3 Fried Tenders OR 3 Grilled Tenders</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Beef Tips</h3>
                </div>
                <p className="text-sm text-gray-700">Open face, with beef tips, grilled mushrooms over toast with gravy</p>
              </div>
            </div>
          </div>

          {/* Salads Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Salads</h2>
            <p className="text-center text-sm text-gray-500 mb-4 italic">Dressings: Ranch, Bleu Cheese, Honey Mustard, Balsamic, Raspberry Vinaigrette, 1000 Island, French, Italian</p>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chef Salad</h3>
                </div>
                <p className="text-sm text-gray-700">Ham, turkey, tomato, cucumber, cheddar, egg & bacon</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Grilled or Fried Chicken</h3>
                </div>
                <p className="text-sm text-gray-700">Tomato, cucumber, and cheddar | Sub. Steak | Add Buffalo</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Chicken Bacon Ranch</h3>
                </div>
                <p className="text-sm text-gray-700">Grilled or fried, with tomato, cucumbers, cheddar & bacon</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Caesar Salad</h3>
                </div>
                <p className="text-sm text-gray-700">Romaine lettuce, parmesan cheese and croutons tossed with Caesar dressing</p>
                <p className="text-sm text-gray-700 mt-1">Chicken | Steak</p>
              </div>
            </div>
          </div>

          {/* Flatbreads Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Flatbreads</h2>

            <div className="space-y-4">
              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">BBQ Chicken</h3>
                </div>
                <p className="text-sm text-gray-700">BBQ sauce base with chicken, bacon, onions, & cheddar cheese</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Buffalo Chicken</h3>
                </div>
                <p className="text-sm text-gray-700">Spicy ranch or Bleu cheese, chicken, jack cheese & hot sauce drizzle</p>
              </div>

              <div className="border-b border-gray-200 pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Philly</h3>
                </div>
                <p className="text-sm text-gray-700">Alfredo sauce, steak, onions, peppers & provolone cheese</p>
              </div>

              <div className="pb-3">
                <div className="flex justify-between items-start mb-1">
                  <h3 className="font-bold text-yellow-800">Cheese or Pepperoni</h3>
                </div>
              </div>
            </div>
          </div>

          {/* Sides Section */}
          <div className="bg-white rounded-lg shadow-lg p-6 w-full break-inside-avoid mb-6">
            <h2 className="text-2xl font-bold text-center uppercase mb-4 text-black">Sides</h2>
            <div className="grid grid-cols-2 gap-2">
              <p className="text-sm text-gray-700">Mashed Potatoes</p>
              <p className="text-sm text-gray-700">Steamed Broccoli</p>
              <p className="text-sm text-gray-700">French Fries</p>
              <p className="text-sm text-gray-700">Coleslaw</p>
              <p className="text-sm text-gray-700">Green Beans</p>
              <p className="text-sm text-gray-700">Sweet Fries</p>
              <p className="text-sm text-gray-700">Homemade Chips</p>
              <p className="text-sm text-gray-700">Pasta Salad</p>
              <p className="text-sm text-gray-700">Tater Tots</p>
              <p className="text-sm text-gray-700">Onion Rings</p>
              <p className="text-sm text-gray-700">Mac & Cheese</p>
              <p className="text-sm text-gray-700">Loaded Mash</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Menu;
